var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import html from "./layout.html";
//import "../components/header";
import "../components/footer";
import "../components/leftMenu";
import Component from "../lib/component";
var MyComponent = /** @class */ (function (_super) {
    __extends(MyComponent, _super);
    function MyComponent() {
        return _super.call(this, "layout", html, { singleInstance: true }) || this;
    }
    MyComponent.prototype.init = function () {
    };
    return MyComponent;
}(Component));
export { MyComponent };
export default new MyComponent();
